import { render, staticRenderFns } from "./HomeAccountData.vue?vue&type=template&id=d96f89ec&scoped=true&"
import script from "./HomeAccountData.vue?vue&type=script&lang=js&"
export * from "./HomeAccountData.vue?vue&type=script&lang=js&"
import style0 from "./HomeAccountData.vue?vue&type=style&index=0&id=d96f89ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d96f89ec",
  null
  
)

export default component.exports